<div class="fast-checkin-duration-container">
  <div class="content-wrapper mt-4">
    <!-- <div class="mb-4 mt-4">{{ 'i18n.domain.fast-checkin.duration-setting-text' | translate }}</div> -->
    @if(hasOffense) {
      <div class="alert alert-danger" role="alert">
        {{ 'i18n.domain.parker-registration.ParkerRegistrationOffense.' + offenseType | translate }}
      </div>
    }
    <form id="fastCheckinDurationForm" [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
      <div class="form-row row narrow-row">
        <div class="form-group col-md-12">
          <div class="d-flex justify-content-between">
            <span class="text-muted">{{ 'i18n.shared.fields.zone' | translate }}</span>
            <strong>{{ zoneInfo.name }}</strong>
          </div>
        </div>
      </div>
      <div class="form-row row">
        <div class="form-group col-md-12">
          <div class="d-flex justify-content-between">
            <span class="text-muted">{{ 'i18n.shared.fields.control-plate' | translate }}</span>
            <strong>{{ controlPlate }}</strong>
          </div>
        </div>
      </div>

      <div class="form-row row narrow-row">
        <div class="form-group col-md-12">
          <div class="d-flex justify-content-between">
            <span class="text-muted">{{ 'i18n.domain.fast-checkin.max-parking-duration' | translate }}:</span>
            <strong>{{ getMaxParkingDurationString() }}</strong>
          </div>
        </div>
      </div>

      <div class="form-row row narrow-row">
        <div class="form-group col-md-12">
          <div class="d-flex justify-content-between">
            <span class="text-muted">{{ 'i18n.domain.fast-checkin.calculated-price' | translate }}:</span>
            <strong class="text-primary">{{ priceWithCurrency }}</strong>
          </div>
        </div>
      </div>

      <hr class="my-3">

      <div class="form-row row mb-2">
        <div class="form-group col-md-12">
          <label for="selectedSubscription" class="form-label">{{ 'i18n.shared.fields.subscription' | translate }}</label>
          <ejs-dropdownlist id="selectedSubscription"
                            formControlName="selectedSubscriptionId"
                            [dataSource]="availableSubscriptions"
                            [fields]="subscriptionDropdownFields"
                            [showClearButton]="false"></ejs-dropdownlist>
          @if(hasFallbackPrice) {
            <small class="text-muted">
              {{ 'i18n.domain.fast-checkin.fallback-price-info' | translate: { param: normalPriceWithCurrency } }}
            </small>
          }
          @if (parkingQuotaInfoTextParams) {
            <small class="subscription-info">
              <span class="e-icons icon-information me-1"></span>{{'i18n.domain.parking.parkingQuotaInfo' | translate: parkingQuotaInfoTextParams}}
            </small>
          }
        </div>
      </div>

      <app-fast-checkin-time-settings
        [startTime]="startTime"
        [durationMinutes]="form.controls.parkingDuration.value"
        [maxDurationMinutes]="getMaxSliderRange()"
        [translationPrefix]="'i18n.domain.fast-checkin'"
        (durationMinutesChange)="onParkingDurationChanged($event)"></app-fast-checkin-time-settings>

      <div class="button-container">
        <div class="form-row row">
          <div class="form-group col-6">
            <div class="d-grid">
              <button type="button" class="btn btn-outline-primary" (click)="back.emit()">
                {{ 'i18n.shared.back' | translate }}
              </button>
            </div>
          </div>
          <div class="form-group col-6">
            <div class="d-grid">
              <button type="submit" class="btn btn-primary" [disabled]="form.invalid || hasOffense">
                {{ 'i18n.domain.fast-checkin.start' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
